<h1 class="title" id="pageTitle" tabindex="-1">{{ current }}</h1>

<nav class="crumbs" fxLayout="row" fxLayoutAlign="start center" aria-label="Breadcrumb">
  <ol class="breadcrumb-list" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <!-- Home -->
    <li>
      <a [routerLink]="['/']" style="text-decoration: underline; cursor: pointer; color:#0a58ca">
        Dashboard
      </a>
    </li>

    <!-- Dynamic crumbs -->
    <li *ngFor="let crumb of crumbs" class="crumb">
      <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
      <a href="#" class="link">{{ crumb }}</a>
    </li>

    <!-- Current page -->
    <li aria-current="page" class="crumb current">
      <mat-icon class="chevron" aria-hidden="true">chevron_right</mat-icon>
      <span class="link">{{ current }}</span>
    </li>
  </ol>
</nav>